import { ReactComponent as ArrowLeftIcon } from '../icons/svg/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../icons/svg/arrow-right.svg';
import { ReactComponent as ArrowsUpIcon } from '../icons/svg/arrows-up.svg';
import { ReactComponent as ArtboardIcon } from '../icons/svg/artboard.svg';
import { ReactComponent as AudienceIcon } from '../icons/svg/audience.svg';
import { ReactComponent as BinocularsIcon } from '../icons/svg/binoculars.svg';
import { ReactComponent as CaseStudyIcon } from '../icons/svg/case_study.svg';
import { ReactComponent as CenterArrowsIcon } from '../icons/svg/center-arrows.svg';
import { ReactComponent as ChatBubblesIcon } from '../icons/svg/chat-bubbles.svg';
import { ReactComponent as ChatIcon } from '../icons/svg/chat.svg';
import { ReactComponent as CircleGraphIcon } from '../icons/svg/circle-graph.svg';
import { ReactComponent as CloseIcon } from '../icons/svg/close.svg';
import { ReactComponent as CollaborationIcon } from '../icons/svg/collaboration.svg';
import { ReactComponent as DownArrowIcon } from '../icons/svg/down-arrow.svg';
import { ReactComponent as EnvelopeIcon } from '../icons/svg/envelope.svg';
import { ReactComponent as ExperimentBubbleLargeIcon } from '../icons/svg/experiment-bubble-large.svg';
import { ReactComponent as ExperimentBubbleSmallIcon } from '../icons/svg/experiment-bubble-small.svg';
import { ReactComponent as ExperimentStaticIcon } from '../icons/svg/experiment-static.svg';
import { ReactComponent as ExperimentIcon } from '../icons/svg/experiment.svg';
import { ReactComponent as EyeIcon } from '../icons/svg/eye.svg';
import { ReactComponent as FlagIcon } from '../icons/svg/flag.svg';
import { ReactComponent as FocusIcon } from '../icons/svg/focus-group.svg';
import { ReactComponent as GraphSheetsIcon } from '../icons/svg/graph-sheets.svg';
import { ReactComponent as GraphsIcon } from '../icons/svg/graphs.svg';
import { ReactComponent as HandIcon } from '../icons/svg/hand.svg';
import { ReactComponent as HeartPlusIcon } from '../icons/svg/heart-plus.svg';
import { ReactComponent as HeartSettingslargeIcon } from '../icons/svg/heart-settings-large.svg';
import { ReactComponent as HeartSettingsIcon } from '../icons/svg/heart-settings.svg';
import { ReactComponent as HeartIcon } from '../icons/svg/heart.svg';
import { ReactComponent as HoopIcon } from '../icons/svg/hoop.svg';
import { ReactComponent as IcCloseIcon } from '../icons/svg/ic-close.svg';
import { ReactComponent as IcLeftIcon } from '../icons/svg/ic-left.svg';
import { ReactComponent as IcLightbulbIcon } from '../icons/svg/ic-lightbulb.svg';
import { ReactComponent as IcRightIcon } from '../icons/svg/ic-right.svg';
import { ReactComponent as IcTopIcon } from '../icons/svg/ic-top.svg';
import { ReactComponent as InfographicsIcon } from '../icons/svg/infographics.svg';
import { ReactComponent as InteractiveGraphsIcon } from '../icons/svg/interactive-graphs.svg';
import { ReactComponent as LightBulbNoRaysIcon } from '../icons/svg/light-bulb-no-rays.svg';
import { ReactComponent as LightBulbOnIcon } from '../icons/svg/light-bulb-on.svg';
import { ReactComponent as LightBulbRaysIcon } from '../icons/svg/light-bulb-rays.svg';
import { ReactComponent as LightBulbTwoIcon } from '../icons/svg/light-bulb-two.svg';
import { ReactComponent as LightBulbIcon } from '../icons/svg/light-bulb.svg';
import { ReactComponent as LineGraphIcon } from '../icons/svg/line-graph.svg';
import { ReactComponent as ListTwoIcon } from '../icons/svg/list-two.svg';
import { ReactComponent as ListIcon } from '../icons/svg/list.svg';
import { ReactComponent as LogoActivisionIcon } from '../icons/svg/logo-activision.svg';
import { ReactComponent as LogoBIcon } from '../icons/svg/logo-b.svg';
import { ReactComponent as LogoBlizzardIcon } from '../icons/svg/logo-blizzard.svg';
import { ReactComponent as LogoCandtIcon } from '../icons/svg/logo-candt.svg';
import { ReactComponent as LogoDisneyIcon } from '../icons/svg/logo-disney.svg';
import { ReactComponent as LogoDreamworksIcon } from '../icons/svg/logo-dreamworks.svg';
import { ReactComponent as LogoEAIcon } from '../icons/svg/logo-ea.svg';
// import { ReactComponent as LogoFinnIcon } from '../icons/svg/logo-finn.svg';
// import { ReactComponent as LogoForwardIcon } from '../icons/svg/logo-forward.svg';
import { ReactComponent as LogoFoxIcon } from '../icons/svg/logo-fox.svg';
import { ReactComponent as LogoHasbroIcon } from '../icons/svg/logo-hasbro.svg';
// import { ReactComponent as LogoHarrisIcon } from '../icons/svg/logo-harris.svg';
// import { ReactComponent as LogoHarrisXIcon } from '../icons/svg/logo-harrisx.svg';
import { ReactComponent as LogoLionsgateIcon } from '../icons/svg/logo-lionsgate.svg';
// import { ReactComponent as LogoMmiIcon } from '../icons/svg/logo-mmi.svg';
import { ReactComponent as LogoNetflixIcon } from '../icons/svg/logo-netflix.svg';
import { ReactComponent as LogoOpenRoadIcon } from '../icons/svg/logo-open-road.svg';
import { ReactComponent as LogoParamountIcon } from '../icons/svg/logo-paramount.svg';
import { ReactComponent as LogoPmxIcon } from '../icons/svg/logo-pmx.svg';
// import { ReactComponent as LogoScoutIcon } from '../icons/svg/logo-scout.svg';
import { ReactComponent as LogoSkdIcon } from '../icons/svg/logo-skd.svg';
import { ReactComponent as LogoSonyIcon } from '../icons/svg/logo-sony.svg';
// import { ReactComponent as LogoStagwtechIcon } from '../icons/svg/logo-stagtech.svg';
import { ReactComponent as LogoStxIcon } from '../icons/svg/logo-stx.svg';
// import { ReactComponent as LogoTargIcon } from '../icons/svg/logo-targ.svg';
import { ReactComponent as LogoUniversalIcon } from '../icons/svg/logo-universal.svg';
import { ReactComponent as LogoWarnerBrosIcon } from '../icons/svg/logo-warner-bros.svg';
// import { ReactComponent as LogoWolfIcon } from '../icons/svg/logo-wolf.svg';
import { ReactComponent as LogoWyeIcon } from '../icons/svg/logo-wye.svg';
import { ReactComponent as LogoXboxIcon } from '../icons/svg/logo-xbox.svg';
import { ReactComponent as LogoZyngaIcon } from '../icons/svg/logo-zynga.svg';
// import { ReactComponent as LogoTwoIcon } from '../icons/svg/logo-two.svg';
import { ReactComponent as LoopIcon } from '../icons/svg/loop.svg';
import { ReactComponent as LoopTwoIcon } from '../icons/svg/loop-two.svg';
import { ReactComponent as MegaphoneIcon } from '../icons/svg/megaphone.svg';
import { ReactComponent as MicrophoneIcon } from '../icons/svg/microphone.svg';
import { ReactComponent as NRGStagwellIcon } from '../icons/svg/nrg-stagwell.svg';
import { ReactComponent as NRGIcon } from '../icons/svg/nrg.svg';
import { ReactComponent as PositioningTwoIcon } from '../icons/svg/positioning-two.svg';
import { ReactComponent as PositioningIcon } from '../icons/svg/positioning.svg';
import { ReactComponent as PresentationBoardIcon } from '../icons/svg/presentation-board.svg';
import { ReactComponent as PriceTagIcon } from '../icons/svg/price-tag.svg';
import { ReactComponent as ScreenTestIcon } from '../icons/svg/screen-test.svg';
import { ReactComponent as ShoppingBagIcon } from '../icons/svg/shopping-bag.svg';
import { ReactComponent as SodaPopcornIcon } from '../icons/svg/soda-popcorn.svg';
import { ReactComponent as SpeakerIcon } from '../icons/svg/speaker.svg';
import { ReactComponent as StarIcon } from '../icons/svg/star.svg';
import { ReactComponent as TrophyIcon } from '../icons/svg/trophy.svg';
import { ReactComponent as VideoIcon } from '../icons/svg/video.svg';
import { ReactComponent as WorkoutIcon } from '../icons/svg/workout.svg';
import { ReactComponent as WorldMapIcon } from '../icons/svg/world-map.svg';



// Import all the svg icons as React Components, when asked about any of them return the component of that svg
const getIcon = (iconName) => {
    // const reqSvgs = require.context ( '../icons/svg/', true, /\.svg$/ );
    // const allSvgFilepaths = reqSvgs.keys();
    // console.log("allSvgFilepaths");
    // console.log(allSvgFilepaths);

    switch (iconName) {
        case 'arrow-left':
            return ArrowLeftIcon;
        case 'arrow-right':
            return ArrowRightIcon;
        case 'arrows-up':
            return ArrowsUpIcon;
        case 'art-board':
            return ArtboardIcon;
        case 'audience':
            return AudienceIcon;
        case 'binoculars':
            return BinocularsIcon;
        case 'case-study':
            return CaseStudyIcon;
        case 'center-arrows':
            return CenterArrowsIcon;
        case 'chat-bubbles':
            return ChatBubblesIcon;
        case 'chat':
            return ChatIcon;
        case 'circle-graph':
            return CircleGraphIcon;
        case 'close':
            return CloseIcon;
        case 'collaboration':
            return CollaborationIcon;
        case 'down-arrow':
            return DownArrowIcon;
        case 'envelope':
            return EnvelopeIcon;
        case 'experiment-bubble-large':
            return ExperimentBubbleLargeIcon;
        case 'experiment-bubble-small':
            return ExperimentBubbleSmallIcon;
        case 'experiment-static':
            return ExperimentStaticIcon;
        case 'experiment':
            return ExperimentIcon;
        case 'eye':
            return EyeIcon;
        case 'flag':
            return FlagIcon;
        case 'focus-group':
            return FocusIcon;
        case 'graph-sheets':
            return GraphSheetsIcon;
        case 'graphs':
            return GraphsIcon;
        case 'hand':
            return HandIcon;
        case 'heart-plus':
            return HeartPlusIcon;
        case 'heart-settings-large':
            return HeartSettingslargeIcon;
        case 'heart-settings':
            return HeartSettingsIcon;
        case 'heart':
            return HeartIcon;
        case 'hoop':
            return HoopIcon;
        case 'ic-close':
            return IcCloseIcon;
        case 'ic-left':
            return IcLeftIcon;
        case 'ic-left-bulb':
            return IcLightbulbIcon;
        case 'ic-right':
            return IcRightIcon;
        case 'ic-top':
            return IcTopIcon;
        case 'artboard':
            return ArtboardIcon;
        case 'infographics':
            return InfographicsIcon;
        case 'interactive-graphs':
            return InteractiveGraphsIcon;
        case 'light-bulb-no-rays':
            return LightBulbNoRaysIcon;
        case 'light-bulb-on':
            return LightBulbOnIcon;
        case 'light-bulb-rays':
            return LightBulbRaysIcon;
        case 'light-bulb-two':
            return LightBulbTwoIcon;
        case 'light-bulb':
            return LightBulbIcon;
        case 'line-graph':
            return LineGraphIcon;
        case 'list-two':
            return ListTwoIcon;
        case 'list':
            return ListIcon;
        case 'logo-activision':
            return LogoActivisionIcon;
        case 'logo-b':
            return LogoBIcon;
        case 'logo-blizzard':
            return LogoBlizzardIcon;
        case 'logo-candt':
            return LogoCandtIcon;
        case 'logo-disney':
            return LogoDisneyIcon;
        case 'logo-dreamworks':
            return LogoDreamworksIcon;
        case 'logo-ea':
            return LogoEAIcon;
        // case 'logo-finn':
        //     return LogoFinnIcon;
        // case 'logo-forward':
        //     return LogoForwardIcon;
        case 'logo-fox':
            return LogoFoxIcon;
        case 'logo-hasbro':
            return LogoHasbroIcon;
        // case 'logo-harris':
        //     return LogoHarrisIcon;
        // case 'logo-harrisx':
        //     return LogoHarrisXIcon;
        case 'logo-lionsgate':
            return LogoLionsgateIcon;
        // case 'logo-mmi':
        //     return LogoMmiIcon;
        case 'logo-netflix':
            return LogoNetflixIcon;
        case 'logo-open-road':
            return LogoOpenRoadIcon;
        case 'logo-paramount':
            return LogoParamountIcon;
        case 'logo-pmx':
            return LogoPmxIcon;
        // case 'logo-scout':
        //     return LogoScoutIcon;
        case 'logo-skd':
            return LogoSkdIcon;
        case 'logo-sony':
            return LogoSonyIcon;
        // case 'logo-stagtech':
        //     return LogoStagwtechIcon;
        case 'logo-stx':
            return LogoStxIcon;
        // case 'logo-targ':
        //     return LogoTargIcon;
        case 'logo-universal':
            return LogoUniversalIcon;
        case 'logo-warner-bros':
            return LogoWarnerBrosIcon;
        // case 'logo-wolf':
        //     return LogoWolfIcon;
        case 'logo-wye':
            return LogoWyeIcon;
        case 'logo-xbox':
            return LogoXboxIcon;
        case 'logo-zynga':
            return LogoZyngaIcon;
        // case 'logo-two':
        //     return LogoTwoIcon;
        case 'loop':
            return LoopIcon;
        case 'loop-two':
            return LoopTwoIcon;
        case 'megaphone':
            return MegaphoneIcon;
        case 'microphone':
            return MicrophoneIcon;
        case 'nrg-stagwell':
            return NRGStagwellIcon;
        case 'nrg':
            return NRGIcon;
        case 'positioning-two':
            return PositioningTwoIcon;
        case 'positioning':
            return PositioningIcon;
        case 'presentation-board':
            return PresentationBoardIcon;
        case 'price-tag':
            return PriceTagIcon;
        case 'screen-test':
            return ScreenTestIcon;
        case 'shopping-bag':
            return ShoppingBagIcon;
        case 'soda-popcorn':
            return SodaPopcornIcon;
        case 'speaker':
            return SpeakerIcon;
        case 'star':
            return StarIcon;
        case 'trophy':
            return TrophyIcon;
        case 'video':
            return VideoIcon;
        case 'workout':
            return WorkoutIcon;
        case 'world-map':
            return WorldMapIcon;
        default:
            return ArrowLeftIcon;
    }
}

export default getIcon;
